import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { PostListingLink } from 'components/Link/PostListingLink';
import {
  DropdownMenuItemRouter,
  PageHeaderDropdownMenu,
  PageHeaderDropdownMenuSection,
} from 'components/Page/Header/PageHeaderDropdownMenu';
import { useAmpContext } from 'utils/AmpContext';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { PageHeaderForOrganizationsContainer } from './PageHeaderForOrganizations.styled';

export function PageHeaderForOrganizations() {
  const isAmp = useAmpContext();

  if (isAmp) return null;

  return (
    <PageHeaderForOrganizationsContainer>
      <PageHeaderDropdownMenu
        title={() => getText('For Organizations')}
        right
        data-qa-id="for-org-dropdown"
        onClick={() => {
          trackClicked('For Organizations');
        }}
        hideArrow={{ lg: true }}
      >
        <PostListingLink
          // @ts-expect-error TS(2322): Type 'StyledComponent<({ to, state, ...props }: Om... Remove this comment to see the full error message
          component={DropdownMenuItemRouter}
          data-qa-id="post-a-listing-dropdown"
          onClick={() => {
            trackClicked('Post A Listing', {
              context: 'Header (For Organizations Dropdown)',
            });
          }}
        >
          {getText('Post a Listing')}
        </PostListingLink>

        <DropdownMenuItemRouter
          to="/organizations/create"
          data-qa-id="create-org"
          onClick={() => {
            trackClicked('Add Your Organization');
          }}
        >
          {getText('Add Your Organization')}
        </DropdownMenuItemRouter>

        {CURRENT_LOCALE === 'en' ? (
          <PageHeaderDropdownMenuSection>
            <DropdownMenuItemRouter to={`/${CURRENT_LOCALE}/orgs/resources`}>
              <Icon initialColorName="selectionGrey" name="paper" size={20} />
              <Box display="inline-block" ml={2}>
                {getText('Resource Center')}
              </Box>
            </DropdownMenuItemRouter>
          </PageHeaderDropdownMenuSection>
        ) : null}
      </PageHeaderDropdownMenu>
    </PageHeaderForOrganizationsContainer>
  );
}
